<template>
  <div>
    <transition name="appfade">
      <div v-show="appIsLoaded" class="app-container" key="app-loaded-1">
        <app-header v-show="!isHeaderFooterHidden"></app-header>
        <transition name="pagefade">
          <router-view :key="$route.fullPath"></router-view>
        </transition>
        <app-footer v-show="!isHeaderFooterHidden"></app-footer>
        <!--<div class="mobile-warning"></div>-->
        <cookie-banner></cookie-banner>
        <modals-container></modals-container>
      </div>
    </transition>
    <transition name="appfade">
      <div v-if="!appIsLoaded" class="is-black" key="app-not-loaded-2">
        <h1>data.json not found or invalid json</h1>
      </div>
    </transition>
  </div>
</template>

<script>
import AppHeader from "./app-header.vue";
import AppFooter from "./app-footer.vue";
import CookieBanner from "./cookie-banner.vue";
export default {
  components: {
    "app-header": AppHeader,
    "app-footer": AppFooter,
    "cookie-banner": CookieBanner
  },
  props: ["appIsLoaded"],
  data() {
    return {
      hiddenHeaderFooterRoutes: [
        "/information",
        "/information/",
        "/news-mobile/",
        "/news-mobile"
      ]
    };
  },
  computed: {
    isHeaderFooterHidden() {
      return this.hiddenHeaderFooterRoutes.includes(this.$route.path)
        ? true
        : false;
    }
  },
  methods: {
    //
  },
  created() {
    //
  },
  mounted() {
    /* Hash Anchor Link functionality */
    if (this.$route.hash) {
      setTimeout(() => {
        var anchorId = this.$route.hash;
        var element = anchorId.replace("#", "");
        document
          .getElementById(element)
          .scrollIntoView({ block: "start", behavior: "smooth" });
      }, 500);
    }
  },
  watch: {
    /*
    $route (to, from) {
      //
    }
    */
  },
  beforeDestroy() {
    //
  },
  updated() {
    //s
  }
};
</script>
